<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('accommodation_management.accommodation_info') + ' ' + $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
            <b-row>
              <b-col lg="6" sm="12">
                  <ValidationProvider name="Fiscal year" vid='fiscal_year_id' rules="">
                      <b-form-group
                          class="row"
                          label-cols-sm="5"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                      >
                          <template v-slot:label>
                          {{ $t('grant_budget_management.fiscal_year') }} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                          plain
                          v-model="search.fiscal_year_id"
                          :options="fiscalYearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                              {{ errors[0] }}
                          </div>
                      </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12">
                <ValidationProvider name="Circular Memo" vid='circular_publication_id' rules="">
                  <b-form-group
                    class="row"
                    label-cols-sm="5"
                    label-for="circular_publication_id"
                    slot-scope="{ valid, errors }"
                  >
                      <template v-slot:label>
                      {{ $t('elearning_config.circular_memo_no') }} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="search.circular_publication_id"
                        :options="circularPublicationList"
                        id="circular_publication_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.all')}}</b-form-select-option>
                        </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                      {{ errors[0] }}
                      </div>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12">
                  <ValidationProvider name="Training Name" vid="training_title_id" rules="">
                  <b-form-group
                      class="row"
                      label-cols-sm="5"
                      label-for="training_title_id"
                      slot-scope="{ valid, errors }"
                  >
                      <template v-slot:label>
                          {{$t('elearning_config.training')}}  <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                      plain
                      v-model="search.training_title_id"
                      id="training_title_id"
                      :options="trainingNameList"
                      :state="errors[0] ? false : (valid ? true : null)"
                  >
                      <template v-slot:first>
                          <b-form-select-option :value="0" >{{$t('globalTrans.all')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                          {{ errors[0] }}
                      </div>
                  </b-form-group>
              </ValidationProvider>
              </b-col>
              <b-col lg="6" sm="12">
                  <b-spinner v-if="spinLoader" class="overlay" variant="success" small label="Spinning"></b-spinner>
                  <ValidationProvider name="Batch" vid="batch_id" rules="">
                      <b-form-group
                          class="row"
                          label-cols-sm="5"
                          label-for="batch_id"
                          slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                              {{ $t('elearning_config.batch') }} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                          plain
                          v-model="search.batch_id"
                          id="batch_id"
                          :options="batchList"
                          :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0" >{{$t('globalTrans.all')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                              {{ errors[0] }}
                          </div>
                      </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col lg="12" md="6" sm="12">
                <b-button type="submit" variant="primary">{{ $t('globalTrans.search') }}</b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('accommodation_management.accommodation_info') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i> {{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(fiscal_year_id)="data">
                      <span>{{ getFiscalYear(data.item.fiscal_year_id) }}</span>
                    </template>
                    <template v-slot:cell(circular_publication_id)="data">
                      <span>{{ getCircularMemo(data.item.circular_publication_id) }}</span>
                    </template>
                    <template v-slot:cell(training_title_id)="data">
                      <span>{{ trainingName(data.item.training_title_id) }}</span>
                    </template>
                      <template v-slot:cell(batch)="data">
                          <span>{{ batchName(data.item.batch_id) }}</span>
                      </template>
                     <template v-slot:cell(status)="data">
                        <span class="badge badge-danger" v-if="data.item.status === 2">{{ $t('globalTrans.inactive') }}</span>
                        <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>
                    <!-- <template v-slot:cell(action)="data">
                      <a href="javascript:" class="btn_table_action btn_rad" title="status" v-if="data.item.status === 2" @click="remove(data.item)">
                        <i class="fas fa-toggle-off"></i>
                      </a>
                      <a href="javascript:" class="btn_table_action btn_blue" title="status" v-else @click="remove(data.item)">
                        <i class="fas fa-toggle-on"></i>
                      </a>
                      <a href="javascript:" title="Edit" class="btn_table_action btn_blue" v-b-modal.modal-4 @click="edit(data.item)"><i class="fas fa-eye m-0"></i></a>
                    </template> -->
                    <template v-slot:cell(action)="data">
                      <router-link :to="{name: 'training_e_learning_service.accommodation_management.accommodation_info_view', params: {item: data.item }}" :class="'btn btn-success text-light fontcus'">
                        <i class="fas fa-eye m-0"></i>
                      </router-link>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Form from './Form'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { accommodationInfoListApi, accommodationInfoToggleStatusApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Form
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        circular_publication_id: 0,
        training_title_id: 0,
        batch_id: 0
      },
      circularPublicationList: [],
      trainingNameList: [],
      batchList: [],
      spinLoader: false,
      editItemId: 0,
      viewitemId: 0,
      rows: []
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    formTitle () {
      return (this.editItemId === 0) ? this.$t('accommodation_management.accommodation_info') + ' ' + this.$t('globalTrans.add') : this.$t('accommodation_management.accommodation_info') + ' ' + this.$t('globalTrans.modify')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
        { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
        { label: this.$t('grant_budget_management.fiscal_year'), class: 'text-left' },
        { label: this.$t('application_management.circular_memo_no'), class: 'text-left' },
        { label: this.$t('elearning_config.training'), class: 'text-left' },
        { label: this.$t('elearning_config.batch'), class: 'text-left' },
        { label: this.$t('globalTrans.action'), class: 'text-center' }
      ]
      let keys = []
      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_id' },
          { key: 'circular_publication_id' },
          { key: 'training_title_id' },
          { key: 'batch' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'fiscal_year_id' },
          { key: 'circular_publication_id' },
          { key: 'training_title_id' },
          { key: 'batch' },
          { key: 'action' }
        ]
      }
      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal) {
      this.search.circular_publication_id = 0
      this.search.training_name_id = 0
      this.search.batch_id = 0
      this.batchList = []
      this.circularPublicationList = this.getMomoList(newVal)
      this.trainingNameList = []
    },
    'search.circular_publication_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search.training_name_id = 0
        this.search.batch_id = 0
        this.batchList = []
        this.trainingNameList = this.trainingList(newVal)
        this.getCircularData()
      }
    },
    'search.training_title_id': function (newVal, oldVal) {
      if (newVal === 0) {
        this.search.batch_id = 0
        this.batchList = []
      }
    }
  },
  created () {
      this.loadData()
  },
  mounted () {
  },
  methods: {
    edit (edititem) {
      this.editItemId = edititem.id
    },
    searchData () {
      this.loadData()
    },
    remove (item) {
      this.changeStatus(trainingElearningServiceBaseUrl, accommodationInfoToggleStatusApi, item)
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(trainingElearningServiceBaseUrl, accommodationInfoListApi, params).then(response => {
        if (response.success) {
          this.$store.dispatch('setList', response.data.data)
          this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getFiscalYear (fiscalYearId) {
      const fiscalObj = this.fiscalYearList.find(item => item.value === fiscalYearId)
      if (fiscalObj !== undefined) {
        return fiscalObj.text
      }
    },
    getCircularMemo (circularMemoId) {
      const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      if (circularObj !== undefined) {
        if (this.$i18n.locale === 'bn') {
          return circularObj.text_bn
        } else {
          return circularObj.text_en
        }
      }
    },
    trainingName (trainingTitleId) {
      const trainingName = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingTitleId)
      if (trainingName !== undefined) {
        if (this.$i18n.locale === 'bn') {
          return trainingName.text_bn
        } else {
          return trainingName.text_en
        }
      }
    },
    batchName (id) {
      const trainingName = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
      if (trainingName !== undefined) {
        if (this.$i18n.locale === 'bn') {
          return trainingName.text_bn
        } else {
          return trainingName.text_en
        }
      }
    },
    async getCircularData () {
      if (this.search.fiscal_year_id && this.search.circular_publication_id) {
        this.spinLoader = true
        const params = {
          fiscal_year_id: this.search.fiscal_year_id,
          circular_id: this.search.circular_publication_id
        }
        const result = await RestApi.getData(trainingElearningServiceBaseUrl, 'training-plan-management/training-routine/circular-data', params)
        if (result.success) {
          if (result.batch.length > 0) {
            this.batchList = result.batch.map((item, index) => {
              return Object.assign({}, { value: item.batch_d.id, text: this.$i18n.locale === 'en' ? item.batch_d.batch : item.batch_d.batch_bn })
            })
          } else {
            this.batchList = []
          }
        }
        this.spinLoader = false
      }
    },
    getMomoList (fiscalYearId) {
      return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
        if (this.$i18n.locale === 'bn') {
          return { value: item.value, text: item.text_bn }
        } else {
          return { value: item.value, text: item.text_en }
        }
      })
    },
    trainingList (circularMemoId) {
      const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
      if (trainingObj !== undefined) {
        return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
          if (this.$i18n.locale === 'bn') {
            return { value: item.value, text: item.text_bn }
          } else {
            return { value: item.value, text: item.text_en }
          }
        })
      }
    }
  }
}
</script>
